/**
 * 2020-06-02
 * Created by Jeremy.caoyu
 * CRM基础验证函数
 *
 */

import qs from "qs";
import { ImagePreview, Toast } from "vant";
import crypto from "crypto";
import md5 from "js-md5";
import { insertTrackingData } from '@/api/activation1.3'


export function formatNumber(num) {
  if(!num) return 0
  const numStr = num.toString()
  return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// 横向柱状图formatter
export const horizontalBarChartFormatter = (value) => {
  let txtString = value.toString()
  let result = ''
  let length = 8,
    subLength = 0
  for (let i = 0, len = txtString.length; i < len; i++) {
    // if (i % 6 === 0 && i != 0) result += '\n'
    result += txtString[i]
    subLength += txtString.charCodeAt(i) > 255 ? 2 : 1
    if (subLength >= length) {
      result += '...'
      break
    }
  }
  return result
}

export const copy = (txt) => {
  let input_dom = document.createElement('input')
  input_dom.value = txt
  document.body.appendChild(input_dom)
  input_dom.select()
  document.execCommand('Copy')
  input_dom.remove()

  Toast('复制成功')
}

export const dialNumber = (phoneNum) => {
  window.location.href = `tel://${phoneNum}`
}


export const isIP = (ip) => {
  let reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
  if (
    reg.test(ip) &&
    RegExp.$1 < 256 &&
    RegExp.$2 < 256 &&
    RegExp.$3 < 256 &&
    RegExp.$4 < 256
  ) {
    return true;
  } else {
    return false;
  }
};

 export function formatDateStr(str)
 {
     return  str.substr(0,4)+'-'+str.substr(4,2)+'-'+str.substr(6)
 }

 export function formatMonthDate(date)
 {
     return (date.getMonth()+1)+'月'+date.getDate()+'日'
 }

export function getNowFormatDate() {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month < 10) month = `0${month}`;
  if (strDate < 10) strDate = `0${strDate}`;
  return `${year}-${month}-${strDate}`;
}

 export function padding (v) {
     let value = v + '';
     if (value.length < 2) {
         value = '0' + value;
     }
     return value;
 }

 export function formatDate (d) {
     return !!d && typeof d !== 'string' ? (d.getFullYear() + '-' + padding(d.getMonth() + 1) + '-' + padding(d.getDate()) + ' ' + padding(d.getHours()) + ':' + padding(d.getMinutes()) + ':' + padding(d.getSeconds()) ) : d;
 }
 
//时间转换 => YYYY-MM-dd
export function format(d) {
  return !!d && typeof d !== "string"
    ? d.getFullYear() +
    "-" +
    padding(d.getMonth() + 1) +
    "-" +
    padding(d.getDate())
    : d;
}

//  正式赛比赛时间与当前时间比较
export function compareTime() {
  let officialStartDate = JSON.parse(localStorage.getItem("teamInfo")).officialStartDate;
  let officialTime = new Date(officialStartDate).getTime();
  let currentTime = new Date().getTime();
  let officialGame;
  if (officialTime < currentTime) {
    officialGame = true;
  } else {
    officialGame = false;
  }
  return officialGame;
}

 export function number2DateTime (value, fmt = 'yyyy-MM-dd HH:mm:ss') { // yyyy-MM-dd HH:mm:ss
     if (isNaN(value)) return '';
     const date = new Date(Number(value));
     const year = date.getFullYear();
     const month = date.getMonth() + 1;
     const day = date.getDate();
     const hour = date.getHours();
     const minute = date.getMinutes();
     const second = date.getSeconds();
     return fmt.replace('yyyy', year.toString())
         .replace('yy', (year % 100).toString())
         .replace('MM', month > 9 ? month.toString() : ("0" + month))
         .replace('dd', day > 9 ? day.toString() : ("0" + day))
         .replace('HH', hour > 9 ? (hour).toString() : ("0" + hour))
         .replace('mm', minute > 9 ? (minute).toString() : ("0" + minute))
         .replace('ss', second > 9 ? (second).toString() : ("0" + second));
 }
 export function isPhone (str) { // 手机号验证
     // let reg = /^(13[0-9]|15[012356789]|17[013678]|18[0-9]|14[57])[0-9]{8}$/;
     //let reg = /^1[3-9][0-9]{9}$/;
     let reg = /^1(3|4|5|6|7|8|9)\d{9}$/
     if (reg.test(str)) {
         return true;
     } else {
         return false;
     }
 }
 export function isTel (str) { // 座机验证
     // let reg = /([0-9]{3,4}-)?[0-9]{7,8}/;
     let reg = /0\d{2}-\d{7,8}/;
     if (reg.test(str)) {
         return true;
     } else {
         return false;
     }
 }
 export function isNumber (value) {
     let patrn = /^[0-9]*$/;
     if (patrn.exec(value) === null || value === "") {
         return false
     } else {
         return true
     }

 }

 export function fillTranslate (str /*, inputType, isAnalyze, inputValue, isMultiSpaceRight */) {
     let s = '', repNum = 0;
     let html = '';
     if (str) {
         if (str.length === 0) return ''
         s = str.replace(/&amp;/g, "&")
             .replace(/&lt;/g, " < ")
             .replace(/&gt;/g, " > ")
             .replace(/&nbsp;/g, " ")
             .replace(/<br\/>/g, "")
             .replace(/<stong\/>/g, "")
             .replace(/&#39;/g, "\'")
             .replace(/&quot;/g, "\"")
             .replace(/\$/g, " $ ")
         // .replace(/___\d___/g,(s,i)=>{
         //     repNum ++
         //     if(!isAnalyze) {
         //         if(inputType[repNum - 1] && !inputType[repNum - 1].input_type) {
         //             html = `<div class="JInput"><div class="textarea q-empty" data-reqNum="${repNum}" id="answer_${repNum}" contenteditable="true"></div></div>`
         //         } else {
         //             html = `<div data-reqNum="${repNum}" id="answer${repNum}" class="divInput"></div>`
         //         }
         //     } else {
         //         if(inputValue.length) {
         //             html = `<div class="user-answer ${ isMultiSpaceRight[repNum - 1] === 'OK' ? 'right' : 'error' }">$ ${ inputValue[repNum - 1] } $</div>`
         //         }
         //     }
         //
         //     return html
         // })
         // .replace(/\#\#\$\$\#\#/g,(s,i)=>{
         //     repNum++
         //     // return  '<span class="fill-mark"><em>______</em><i>'+repNum+'</i></span>'
         //     return  '<span id="answer_'+repNum+'" class="imitate_input" contentEditable="true">______</span>'
         // })
         return s
     }
 }
 // 图片预览
 export function ShowImagePreview (id) {
     document.querySelector(id).addEventListener("click", function (e) {
         window.event ? window.event.cancelBubble = true : e.stopPropagation();
         if ((e.target.tagName === "IMG") || (e.target.tagName === "img")) {
             const images = document.querySelectorAll(`${id} img`)
             let imgURL = []
             for (let i = 0; i < images.length; i++) {
                 imgURL.push(images[i].src)
             }
             ImagePreview({
                 images: imgURL,
                 startPosition: imgURL.indexOf(e.target.src) || 0
             })

         }
     })
 }
 export const getUrlKey = (name) => {
     return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
 }

 export function formatTime (second) {
     let m = Math.floor(second / 60)
     let s = second - m * 60
     m = m < 10 ? '0' + m : m + ''
     s = s < 10 ? '0' + s : s + ''
     return m + ':' + s
 }
 export function isPassword (str) { // 密码验证
     let reg = /^[0-9a-zA-Z]{6,32}$/
     if (isOrder(str) > -1) {
         return false
     }

     if (removeRepeatStr(str).length === 1) {
         return false
     }
     if (!reg.test(str)) {
         return false
     }
     return true

 }
 //字符串去重
 export function removeRepeatStr (str) {
     let newStr = '';
     let flag;
     let len = str.length;
     for (let i = 0; i < len; i++) {
         flag = 1;
         let newLen = newStr.length;
         for (let j = 0; j < newLen; j++) {
             if (str[i] == newStr[j]) {
                 flag = 0;
                 break;
             }
         }
         if (flag) {
             newStr = newStr + str[i];
         }
     }
     return newStr;
 }
 export function isOrder (str) {
     let simple = ['0123456789', 'abcdefghijklmnopqrstuvwxyz', 'ABCDEFGHIJKLMNOPQRSTUVXYZ']
     for (let i = 0; i < simple.length; i++) {
         if (simple[i].indexOf(str) > -1) {
             return simple[i].indexOf(str)
         }
     }
 }
 export function sort_ASCII (obj) {
     var arr = new Array();
     var num = 0;
     for (var i in obj) {
         arr[num] = i;
         num++;
     }
     var sortArr = arr.sort();
     var sortObj = {};
     for (var i in sortArr) {
         sortObj[sortArr[i]] = obj[sortArr[i]];
     }
     return qs.stringify(sortObj);
 }
 export function GetRequest (urlStr) {
     if (typeof urlStr == "undefined") {
         var url = decodeURI(location.search); //获取url中"?"符后的字符串
     } else {
         var url = "?" + urlStr.split("?")[1];
     }
     var theRequest = new Object();
     if (urlStr.indexOf("?") != -1) {
         var str = url.substr(1),
             strs = str.split("&");
         for (var i = 0; i < strs.length; i++) {
             theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
         }
     } else {
         theRequest = null
     }
     return theRequest;
 }
 export function trim (str) { // 去空格
     return str.replace(/\s/g, '');
 }
 export function getSgState () {
     const sgStateStr = (GetRequest(location.search) || {}).sgState
     return sgStateStr ? qs.parse(decodeURIComponent(sgStateStr)) : {}
 }
 export function keySort (obj) {
     const newkey = Object.keys(obj).sort()
     const newObj = {}
     for (var i = 0; i < newkey.length; i++) {
         newObj[newkey[i]] = obj[newkey[i]]
     }
     return newObj
 }
 export function getSign (obj) {
     let secret_key = 'golyXZGv4ZMHEDmefoDrPfrs0QZzRHEB'
     console.log(process.env, 'process.env')
     // const NODE_ENV = process.env.NODE_ENV
     if (process.env.VUE_APP_ENV == 'test' || process.env.VUE_APP_ENV == 'development') {
         secret_key = 'golyXZGv4ZMHEDmefoDrPfrs0QZzRHEB'
     } else {
         secret_key = 'fYqnSe78beWlmNCajzTTQ84l364Yjo30'
     }

     if (typeof obj.sign !== 'undefined') {
         delete obj.sign
     }
     const temp = keySort(obj)

     let protoSign = ''
     for (var d in temp) {
         protoSign += d + '=' + temp[d] + '&'
     }
     protoSign = protoSign.substring(0, protoSign.length - 1)
     protoSign += secret_key
     console.log(process.env.VUE_APP_ENV, protoSign, 'protoSignprotoSign')

     const md5 = crypto.createHash('md5')
     md5.update(protoSign)
     var sign = md5.digest('hex')
     return sign
 }

 export function getCrmSign (obj) {
     let secret_key = '08wMZ7NFz9G52BKX'
     if (typeof obj.sign !== 'undefined') {
         delete obj.sign
     }

     let protoSign = ''
     protoSign = secret_key + Date.parse(new Date()) / 1000
     const md5 = crypto.createHash('md5')
     md5.update(protoSign)
     var sign = md5.digest('hex')
     return sign
 }

 export function getOldCrmSign (obj) {
     let secret_key = 'e6215a1c5d8f818595e25fc02dd16230'
     if (typeof obj.sign !== 'undefined') {
         delete obj.sign
     }

     let protoSign = ''
     protoSign = secret_key + Date.parse(new Date()) / 1000
     const md5 = crypto.createHash('md5')
     md5.update(protoSign)
     var sign = md5.digest('hex')
     return sign
 }

 export function getAgentSign (obj) {
     let secret_key = 'eWnIx3SCTRopyYi2'
     if (typeof obj.sign !== 'undefined') {
         delete obj.sign
     }

     let protoSign = ''
     protoSign = secret_key + Date.parse(new Date()) / 1000
     const md5 = crypto.createHash('md5')
     md5.update(protoSign)
     var sign = md5.digest('hex')
     return sign
 }

 export function getStudySign1 (obj) {
     let secret_key = 'Wwo0b4VLiuctkEEPaXchgAOPXKl2828Z'
     console.log(process.env, 'process.env')
     if (process.env.VUE_APP_ENV == 'test' || process.env.VUE_APP_ENV == 'development') {
         secret_key = 'Wwo0b4VLiuctkEEPaXchgAOPXKl2828Z'
     } else {
         secret_key = 'cEjhl46amgpeGnEWNEvsjdIgt7ylsESp'
     }

     if (typeof obj.sign !== 'undefined') {
         delete obj.sign
     }
     const temp = keySort(obj)

     let protoSign = ''
     for (var d in temp) {
         protoSign += d + '=' + temp[d] + '&'
     }
     protoSign = protoSign.substring(0, protoSign.length - 1)
     protoSign += secret_key
     console.log(process.env.VUE_APP_ENV, protoSign, 'protoSignprotoSign')

     // const md5 = protoSign.createHash('md5')
     // md5.update(protoSign)
     // var sign = md5(protoSign)
     const sign = md5(protoSign)
     return sign
 }

 export function getStudySign(obj) {
     let secret_key = 'Wwo0b4VLiuctkEEPaXchgAOPXKl2828Z'
     console.log(process.env, 'process.env')
     if (process.env.VUE_APP_ENV == 'test' || process.env.VUE_APP_ENV == 'development') {
         secret_key = 'Wwo0b4VLiuctkEEPaXchgAOPXKl2828Z'
     } else {
         secret_key = 'cEjhl46amgpeGnEWNEvsjdIgt7ylsESp'
     }
     if (typeof obj.sign !== 'undefined') {
       delete obj.sign
     }
     const temp = keySort(obj)
     const appkey = secret_key

     let protoSign = ''
     for (var d in temp) {
       protoSign += d + '=' + temp[d] + '&'
     }
     protoSign = protoSign.substring(0, protoSign.length - 1)
     protoSign += appkey
     // const md5 = crypto.createHash('md5')
     // md5.update(protoSign)
     // var sign = md5.digest('hex')

     var sign = md5(protoSign);
     // hash.update();
     // hash.hex();
     return sign
   }

 export function getStamp () {
     const timeStamp = Date.parse(new Date()) / 1000
     return timeStamp
 }

 export function getRandom (num) {
     var random = Math.floor((Math.random() + Math.floor(Math.random() * 9 + 1)) * Math.pow(10, num - 1))
     return random
 }

 /**
  * 格式化人民币
  * @param {float} price
  * @returns
  */
 export function formatPrice (price) {
     var price = ('' + price).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
     return price;
 }


 //检测控制只能输入小数点后2位方法


export function checkInput(num) {
  let str = num.toString();

  var len1 = str.substr(0, 1);

  var len2 = str.substr(1, 1);

  //如果第一位是0，第二位不是点，就用数字把点替换掉

  if (str.length > 1 && len1 == 0 && len2 != ".") {
    str = str.substr(1, 1);
  }

  //第一位不能是.

  if (len1 == ".") {
    str = "";
  }

  //限制只能输入一个小数点

  if (str.indexOf(".") != -1) {
    var str_ = str.substr(str.indexOf(".") + 1);

    if (str_.indexOf(".") != -1) {
      str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
    }

    if (str_.length > 2) {
      let preStr = str.substr(0, str.indexOf("."));

      Toast(`金额小数点后只能输入两位，请正确输入！`);
      return (str = preStr + "." + str_.substr(0, 2));
    }
  }

  //正则替换

  str = str.replace(/[^\d^\.]+/g, ""); // 保留数字和小数点

  return str;
}



 export function debounce(func, wait, immediate) {
     var timeout;

     return function() {
       var context = this;
       var args = arguments;

       if (timeout) clearTimeout(timeout);
       if (immediate) {
         // 如果已经执行过，不再执行
         var callNow = !timeout;
         timeout = setTimeout(function() {
           timeout = null;
         }, wait);
         if (callNow) func.apply(context, args);
       } else {
         timeout = setTimeout(function() {
           func.apply(context, args);
         }, wait);
       }
     };
   }

 // watermark('这是第一段文字','这是第二段文字')
 export function watermark(t1, t2) {
   //t1='削亚飞'
   t1 = `${t1}　${t1} `;
   t2 = "";
   var mark_divs = document.getElementsByClassName("mark_div");
   if (mark_divs.length > 0) {
     for (var i = mark_divs.length - 1; i >= 0; i--) {
       document.body.removeChild(mark_divs[i]);
     }
   }
   var maxWidth = document.documentElement.offsetWidth;
   var maxHeight = document.documentElement.offsetHeight;
   var intervalWidth = 340; //间隔宽度
   var intervalheight = 200; //间隔高度
   var rowNumber = (maxWidth - 40 - 200) / intervalWidth; //横向个数
   var coumnNumber = (maxHeight - 40 - 80) / intervalheight; //纵向个数

   //默认设置
   var defaultSettings = {
     watermark_color: "#CCCCCC", //水印字体颜色
     watermark_alpha: 0.4, //水印透明度
     watermark_fontsize: "24px", //水印字体大小
     watermark_font: "微软雅黑", //水印字体
     watermark_width: 600, //水印宽度
     watermark_height: 80, //水印长度
     watermark_angle: 15, //水印倾斜度数
   };
   var _temp = document.createDocumentFragment();
   for (var i = 0; i < rowNumber; i++) {
     for (var j = 0; j < coumnNumber; j++) {
       var x = intervalWidth * i + 20;
       var y = intervalheight * j + 30;
       var mark_div = document.createElement("div");
       mark_div.id = "mark_div" + i + j;
       mark_div.className = "mark_div";
       ///三个节点
       var span0 = document.createElement("div");
       span0.style.textAlign = "left";
       span0.style.paddingLeft = "30px";
       span0.style.whiteSpace = "nowrap";

       span0.appendChild(document.createTextNode(t1));
       var span1 = document.createElement("div");
       span1.appendChild(document.createTextNode(t2));
       mark_div.appendChild(span0);
       mark_div.appendChild(span1);
       //设置水印div倾斜显示
       mark_div.style.webkitTransform =
         "rotate(-" + defaultSettings.watermark_angle + "deg)";
       mark_div.style.MozTransform =
         "rotate(-" + defaultSettings.watermark_angle + "deg)";
       mark_div.style.msTransform =
         "rotate(-" + defaultSettings.watermark_angle + "deg)";
       mark_div.style.OTransform =
         "rotate(-" + defaultSettings.watermark_angle + "deg)";
       mark_div.style.transform =
         "rotate(-" + defaultSettings.watermark_angle + "deg)";
       mark_div.style.visibility = "";
       mark_div.style.position = "absolute";
       mark_div.style.left = x - 20 + "px";
       mark_div.style.top = y + "px";
       mark_div.style.overflow = "hidden";
       mark_div.style.zIndex = "9";
       mark_div.style.pointerEvents = "none"; //pointer-events:none  让水印不阻止交互事件
       mark_div.style.opacity = defaultSettings.watermark_alpha;
       mark_div.style.fontSize = defaultSettings.watermark_fontsize;
       mark_div.style.fontFamily = defaultSettings.watermark_font;
       mark_div.style.color = defaultSettings.watermark_color;
       mark_div.style.textAlign = "center";
       mark_div.style.width = defaultSettings.watermark_width + "px";
       mark_div.style.height = defaultSettings.watermark_height + "px";
       mark_div.style.display = "block";
       _temp.appendChild(mark_div);
     }
   }
   document.body.appendChild(_temp);
 }



 export function getCurrentTime() {
     let date = new Date(),
     Y = date.getFullYear(), // 年
     M = date.getMonth() + 1, //月
     D = date.getDate(), //日
     h = date.getHours(), //小时
     m = date.getMinutes(), //分钟
     s = date.getSeconds(); //秒数
     return  Y + '-' + getZero(M) + '-' + getZero(D) + ' ' + getZero(h) + ':' +
     getZero(m) + ':' + getZero(s);
 }

 function getZero(num) { // 个位数前补0
     if (parseInt(num) < 10) {
         num = '0' + num;
     }
     return num;
 }


 export function formatSeconds(dec) {
     // dec = 380000;
     var d = parseInt(dec / 60 / 60 / 24);
     // d = d<10 ? '0'+ d : d;
     //得到小时 格式化成前缀加零的样式
     var h = parseInt((dec / 60 / 60) % 24);
     //  h = h<10 ? '0'+ h : h;
     //得到分钟 格式化成前缀加零的样式
     var m = parseInt((dec / 60) % 60);
     // m = m<10 ? '0'+ m: m;

     //得到秒 格式化成前缀加零的样式
     let s = parseInt(dec % 60);
     // s = s<10 ? '0'+ s : s;

     // <span>8</span>小时<span>45</span>分钟
     let str = "";
     if (d > 0) {
         str += `${d}<span style="font-size:16px">天</span>`;
     }
     if (h > 0) {
         str += `${h}<span style="font-size:16px">小时</span>`;
     }

     if (m > 0) {
         str += `${m}<span style="font-size:16px">分钟</span>`;
     }
     if (d <= 0 && h <= 0 && m <= 0) {
         if (s > 0) {
             str += `${s}<span style="font-size:16px">秒</span>`;
         }
     }
     return str;
 }


// 获取松鼠杯的标识 '2023_summer'
export function getCupSeason(cup) {
  let arr = cup.split("_");
  return [arr[0], arr[1], arr[1] + "_" + arr[0]];
}
//获取 2023.2.5 这种格式的时间
export function timeFormatFilter(date) {
  if (!date) {
    return "";
  }
  let time = new Date(date);
  let year = time.getFullYear();
  let month = time.getMonth() + 1;
  let day = time.getDate(); //必须要 getDate
  return year + "." + month + "." + day;
}
//获取 2023.2.5 这种格式的时间，传入的为20230706格式
export function timeFormatFilter2(date) {
  let dateString = date + "";
  if (!dateString) {
    return "";
  }
  var year2 = dateString.substr(0, 4);
  var month2 = dateString.substr(4, 2) - 1; // 月份从 0 开始，所以需要减去 1
  var day2 = dateString.substr(6, 2);
  let time = new Date(year2, month2, day2);

  let year = time.getFullYear();
  let month = time.getMonth() + 1;
  let day = time.getDate(); //必须要 getDate
  return year + "." + month + "." + day;
}
//获取  7 月 6 日 这种格式的时间
export function timeFormatMonthDay(date) {
  if (!date) {
    return "";
  }
  let time = new Date(date);
  let month = time.getMonth() + 1;
  let day = time.getDate(); //必须要 getDate
  return month + "月" + day + "日";
}
// 时间转换成yy-MM
export function yearMonthFormat(data) {
  let year = (data.getFullYear()).toString()
  // year = year.slice(2,4)
  let month = data.getMonth() + 1
  month = month < 10 ? `0${month}` : month
  return `${year}${month}`
}
//获取真正准确赛季
export function judgeSeason(flag = true) {
  let gameTime = JSON.parse(localStorage.getItem("teamInfo")).title;
  if (flag) {
    localStorage.setItem("tempFlag", gameTime); //设置 tempFlag
  }
  const year = gameTime.split("_")[0];
  const season = gameTime.split("_")[1];
  let isSpring;
  let isSummer;
  let isAutumn;
  if (gameTime == "2023_spring") {
    isSpring = true;
  }
  if (gameTime == "2023_summer" || gameTime == "2024_summer" || gameTime == "2025_summer") {
    isSummer = true;
  }
  if (gameTime == "2023_autumn") {
    isAutumn = true;
  }
  return [isSpring, isSummer, isAutumn, year, season];
}
//获取临时赛季（海报用、历史赛季用）
export function judgeTempSeason() {
  let gameTime = localStorage.getItem("tempFlag"); //设置 tempFlag
  const year = gameTime.split("_")[0];
  const season = gameTime.split("_")[1];
  let isSpring = true;
  if (gameTime != "2023_spring") {
    isSpring = false;
  }
  return [isSpring, year, season];
}

function getWinNum(wining_num) {
  let text = "";
  switch (wining_num) {
    case 3:
      text = "三";
      break;
    case 4:
      text = "四";
      break;
    case 5:
      text = "五";
      break;
    case 6:
      text = "六";
      break;
    case 7:
      text = "七";
      break;
    case 8:
      text = "八";
      break;
    case 9:
      text = "九";
      break;
  }
  return text;
}

// 获取战队荣誉海报数据
export function getTeamHonorPosterData(data, teamInfo) {
  let [isSpring] = judgeTempSeason();
  // 通用海报
  let teamHonorPosterData = {
    date: data.day,
    warZone: data.war_zone,
  };
  switch (data.type) {
    case 6: // 6冠军战队
      teamHonorPosterData.rank = 1;
      teamHonorPosterData.teamHonorStatus = 11;
      if (isSpring) {
        teamHonorPosterData.posterDesc =
          teamInfo.cupName + data.war_zone + "冠军";
      } else {
        teamHonorPosterData.posterDesc =
          teamInfo.cupName.slice(3) + data.war_zone + "战区冠军战队";
      }

      break;
    case 7: // 7亚军战队
      teamHonorPosterData.teamHonorStatus = 11;
      teamHonorPosterData.rank = 2;
      if (isSpring) {
        teamHonorPosterData.posterDesc =
          teamInfo.cupName + data.war_zone + "亚军";
      } else {
        teamHonorPosterData.posterDesc =
          teamInfo.cupName.slice(3) + data.war_zone + "战区亚军战队";
      }
      break;
    case 8: // 8季军战队
      teamHonorPosterData.rank = 3;
      teamHonorPosterData.teamHonorStatus = 11;
      if (isSpring) {
        teamHonorPosterData.posterDesc =
          teamInfo.cupName + data.war_zone + "季军";
      } else {
        teamHonorPosterData.posterDesc =
          teamInfo.cupName.slice(3) + data.war_zone + "战区季军战队";
      }
      break;
    case 1: // 1最强战队
      teamHonorPosterData.posterDesc = "单日战队奖杯数全网排名第一";
      teamHonorPosterData.teamHonorStatus = 3;
      break;
    case 2: // 2连胜战队
      let winText = getWinNum(data.wining_num);
      teamHonorPosterData.posterDesc = `战队连续${winText}天战胜对手`;
      teamHonorPosterData.teamHonorStatus = 4;
      teamHonorPosterData.winingNum = data.wining_num;
      break;
    case 3: // 3最精彩的比赛
      teamHonorPosterData.posterDesc = "与对手一起贡献了单日最小差距的激烈比赛";
      teamHonorPosterData.teamHonorStatus = 5; // 最精彩
      break;
    case 4: // 4满勤战队
      teamHonorPosterData.posterDesc = "战队所有成员完成单日PK局数上限";
      teamHonorPosterData.teamHonorStatus = 6;
      break;
    case 5: // 5最强战队（赛季）
      teamHonorPosterData.posterDesc =
        teamInfo.cupName + "战队奖杯数全网排名第一";
      teamHonorPosterData.teamHonorStatus = 2;
      break;
    case 10: // 10 最强战队（战区）
      teamHonorPosterData.posterDesc = "单日战队奖杯数战区排名第一";
      teamHonorPosterData.teamHonorStatus = 10;
      break;
    case 11: // 全国冠军战队
      teamHonorPosterData.rank = 1;
      teamHonorPosterData.teamHonorStatus = 1;
      teamHonorPosterData.posterDesc =
        teamInfo.cupName.slice(3) + "全国冠军战队";
      break;
    case 12: // 全国亚军战队
      teamHonorPosterData.rank = 2;
      teamHonorPosterData.teamHonorStatus = 1;
      teamHonorPosterData.posterDesc =
        teamInfo.cupName.slice(3) + "全国亚军战队";
      break;
    case 13: // 全国季军战队
      teamHonorPosterData.rank = 3;
      teamHonorPosterData.teamHonorStatus = 1;
      teamHonorPosterData.posterDesc =
        teamInfo.cupName.slice(3) + "全国季军战队";
      break;
    case 14: // 8强
      teamHonorPosterData.winingNum = 1;
      teamHonorPosterData.teamHonorStatus = 12;
      teamHonorPosterData.posterDesc =
        teamInfo.cupName.slice(3) + "全国8强战队";
      break;
    case 15: // 16强
      teamHonorPosterData.winingNum = 2;
      teamHonorPosterData.teamHonorStatus = 12;
      teamHonorPosterData.posterDesc =
        teamInfo.cupName.slice(3) + "全国16强战队";
      break;
    case 16: // 32强
      teamHonorPosterData.winingNum = 3;
      teamHonorPosterData.teamHonorStatus = 12;
      teamHonorPosterData.posterDesc =
        teamInfo.cupName.slice(3) + "全国32强战队";
      break;
    case 17: // 战队晋级到全国大赛-通过在精英争霸赛中努力拼搏晋级全国大赛 17
      teamHonorPosterData.teamHonorStatus = 14;
      teamHonorPosterData.posterDesc = "通过在精英争霸赛中努力拼搏晋级全国大赛";
      break;
    case 18: // 战队晋级到精英争霸赛-从全网大乱斗中脱颖而出晋级精英争霸赛 18
      teamHonorPosterData.teamHonorStatus = 13;
      teamHonorPosterData.posterDesc = "从全网大乱斗中脱颖而出晋级精英争霸赛";
      break;
    case 19: // 赛区最强
      teamHonorPosterData.teamHonorStatus = 19;
      teamHonorPosterData.posterDesc = "单日战队奖杯数赛区排名第一";
      break;  
    case 105: // 竞技场今日最强战队
      teamHonorPosterData.teamHonorStatus = 15;
      teamHonorPosterData.posterDesc = "单日奖杯数竞技场排名第一";
      break;
    case 101: // 竞技场无冕之王
      teamHonorPosterData.rank = 1;
      teamHonorPosterData.teamHonorStatus = 16;
      teamHonorPosterData.posterDesc = "竞技场累计奖杯数排名第一";
      break;
    case 102: // 竞技场第二
      teamHonorPosterData.rank = 2;
      teamHonorPosterData.teamHonorStatus = 16;
      teamHonorPosterData.posterDesc = "竞技场累计奖杯数排名第二";
      break;
    case 103: // 竞技场第三
      teamHonorPosterData.rank = 3;
      teamHonorPosterData.teamHonorStatus = 16;
      teamHonorPosterData.posterDesc = "竞技场累计奖杯数排名第三";
      break;
    case 104: // 竞技场第四
      teamHonorPosterData.rank = 4;
      teamHonorPosterData.teamHonorStatus = 16;
      teamHonorPosterData.posterDesc = "竞技场累计奖杯数排名第四";
      break;
    case 100: // 巅峰之王
      teamHonorPosterData.teamHonorStatus = 17;
      teamHonorPosterData.posterDesc = "巅峰赛获得胜利的战队";
      break;
  }
  return teamHonorPosterData;
}
// 是否是2023春季赛
export function isSpringSeason(cupYear, cupSeason) {
  return cupYear == 2023 && cupSeason === "spring";
}

function getAcquireDescribe(data, teamInfo, isSpring = false) {
  let acquireDescribe = "";
  switch (data.type) {
    case 6: //赛区冠军战队
      if (isSpring) {
        acquireDescribe = teamInfo.cupName + data.war_zone + "冠军";
      } else {
        acquireDescribe =
          teamInfo.cupName.slice(3) + data.war_zone + "战区冠军战队";
      }

      break;
    case 7: // 赛区亚军战队
      if (isSpring) {
        acquireDescribe = teamInfo.cupName + data.war_zone + "亚军";
      } else {
        acquireDescribe =
          teamInfo.cupName.slice(3) + data.war_zone + "战区亚军战队";
      }
      break;
    case 8: // 赛区季军战队
      if (isSpring) {
        acquireDescribe = teamInfo.cupName + data.war_zone + "季军";
      } else {
        acquireDescribe =
          teamInfo.cupName.slice(3) + data.war_zone + "战区季军战队";
      }
      break;
    case 11: // 团队赛全国冠军
      acquireDescribe = teamInfo.cupName.slice(3) + "全国冠军战队";
      break;
    case 12: // 团队赛全国亚军
      acquireDescribe = teamInfo.cupName.slice(3) + "全国亚军战队";
      break;
    case 13: // 团队赛全国季军
      acquireDescribe = teamInfo.cupName.slice(3) + "全国季军战队";
      break;
    case 14: // 8强
      acquireDescribe = teamInfo.cupName.slice(3) + "全国8强战队";
      break;
    case 15: // 16强
      acquireDescribe = teamInfo.cupName.slice(3) + "全国16强战队";
      break;
    case 16: // 32强
      acquireDescribe = teamInfo.cupName.slice(3) + "全国32强战队";
    case 19: // 赛区最强
      acquireDescribe = '赛区最强';  
      break;
  }
  return acquireDescribe;
}
// 获取荣誉标题
function getHonorTitle(data, isSpring = false) {
  let title = data.title;
  switch (data.type) {
    case 6: //赛区冠军战队
      title = data.war_zone + "战区冠军";
      break;
    case 7: // 赛区亚军战队
      title = data.war_zone + "战区亚军";
      break;
    case 8: // 赛区季军战队
      title = data.war_zone + "战区季军";
      break;
    case 10: // 赛区季军战队
      title = data.war_zone + "今日最强战队";
      // title = '最强战队（战区）';
      break;
    case 19: // 赛区季军战队
      title = data.war_zone + "赛区今日最强战队";
      // title = '最强战队（赛区）';
      break;  
  }
  return title;
}

// 获取荣耀描述
export function getHonorDesc(item, honorDescMap, teamInfo) {
  let [isSpring] = judgeTempSeason();
  item.honorDesc = Object.assign({}, honorDescMap.get(item.type)); //TODO 需要根据实际的 type 来，在 Map 中进行配置
  item.honorDesc.acquireTime = item.day;
  if (item.type == 9) {
    let member = item.data ? JSON.parse(item.data) : item.data;
    item.honorDesc.userName = member.real_name;
    item.honorDesc.cupNumber = member.score;
    item.honorDesc.accountId = member.account_id;
  }
  let dataTypes = [6, 7, 8, 11, 12, 13, 14, 15, 16];
  if (dataTypes.includes(item.type)) {
    item.honorDesc.acquireDescribe = getAcquireDescribe(
      item,
      teamInfo,
      isSpring
    );
  }
  if (item.type == 2) {
    // 连胜从3，4，5...9 连胜
    let winText = getWinNum(item.wining_num);
    let winTitle = getWinNum(item.wining_num);
    item.honorDesc.title = `${winText}连胜战队`;
    item.honorDesc.acquireDescribe = `战队连续${winText}天战胜对手`;
  }
  if (item.type == 5) {
    item.honorDesc.acquireDescribe = `${teamInfo.cupName}战队奖杯数排名第一`;
  }
  // if (item.type === 11 || item.type === 12 || item.type === 13) {
  //   item.honorDesc.title = item.honorDesc.title.replace("战队", "");
  // }
  item.honorDesc.warZone = item.war_zone;

  const types = [6, 7, 8, 10, 19]; // 战区中的冠 亚 季
  if (types.includes(item.type)) {
    item.honorDesc.title = getHonorTitle(item, isSpring);
  }
  return item;
}

/**
 * 获取赛程类型 1:大乱斗 2：精英争霸赛 3：全国大赛
 * @param seasonTagId
 * @returns {number}
 */
export function getGameType(seasonTagId) {
  if (!seasonTagId) {
    return;
  }
  if (seasonTagId.indexOf("daluandou") !== -1 && seasonTagId.indexOf("jingjichang") == -1) {
    return 1;
  } else if (seasonTagId.indexOf("jingying") !== -1) {
    return 2;
  } else if (seasonTagId.indexOf("xiaozu") !== -1) {
    return 3; //3 是小组赛
  } else if (seasonTagId.indexOf("taotai") !== -1) {
    return 4; //4 是淘汰赛
  } else if (seasonTagId.indexOf("dianfeng") !== -1) {
    return 5;
  } else if (seasonTagId.indexOf("jingjichang.daluandou") !== -1) {
    return 6;
  } else if (seasonTagId.indexOf("tuandui") !== -1 && seasonTagId.indexOf("reshen") == -1 && seasonTagId.indexOf("jingjichang") == -1) {
    return 7;
  } else if (seasonTagId.indexOf("tuandui") !== -1 && seasonTagId.indexOf("reshen") !== -1 && seasonTagId.indexOf("jingjichang") == -1) {
    return 8;
  } else if (seasonTagId.indexOf("jingjichang.zhengbasai") !== -1 || seasonTagId.indexOf("jingjichang.zhengba") !== -1) {
    return 9;
  } 
  /*skd.23.xiaji.1.jingying.test
  skd.23.xiaji.1.xiaozu.test
  skd.23.xiaji.1.taotai.test
  skd.23.xiaji.1.daluandou.test
  - 全国大赛-竞技场: skd.23.xiaji.1.tuandui.jingjichang.test
  - 巅峰赛: skd.23.xiaji.1.tuandui.dianfeng.test
  */
}
/**
 * 微信分享
 * @param {微信签名等信息} data
 * @param {配置内容} shareData
 */
export function wxShare(data, shareData) {
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: data.appId, // 必填，公众号的唯一标识
    timestamp: data.timestamp, // 必填，生成签名的时间戳
    nonceStr: data.noncestr, // 必填，生成签名的随机串
    signature: data.signature, // 必填，签名
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的JS接口列表
    success: () => { },
  })
  wx.ready(function () {
    wx.updateAppMessageShareData({
      title: shareData.title,
      desc: shareData.desc,
      link: shareData.link || location.href.split('#')[0],
      imgUrl: shareData.imgUrl,
      trigger: function trigger(res) { },
      success: function success(res) { },
      cancel: function cancel(res) { },
      fail: function fail(res) { }
    });
    wx.updateTimelineShareData({
      title: shareData.title,
      link: shareData.link || location.href.split('#')[0],
      imgUrl: shareData.imgUrl,
      trigger: function trigger(res) { },
      success: function success(res) { },
      cancel: function cancel(res) { },
      fail: function fail(res) { }
    });
  })
  wx.error((res) => {
    console.log(JSON.stringify(res) + "微信验证失败");
  });
}

export function trackEvent(pointType,params) {
  
  // 这里可以添加实际的埋点逻辑，比如发送请求到埋点服务器
  console.log(`Event: ${pointType}`, params);
  const userInfo = JSON.parse(localStorage.getItem("getDingUserInfo") || '{}')||{};

  console.log(userInfo,'sssssssss');
  try {
    let param = {
      userId: userInfo?.userId, // 账号id
      campusId: userInfo?.campusId, // 经销商id
      pointType, // 埋点key
      ...params
    };
    insertTrackingData(param);
  }catch(e){
    console.log(e,'214124124-=====》〉');
  }

}

export function formatDateBySymbol(date=new Date(),symbol="-") {
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  return `${year}${symbol}${month}${symbol}${day}`;
}